/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import Image from 'material/embeds/imageapi/imagepane/image/image_container';
import Loading from 'material/embeds/imageapi/imagepane/loading/loading';
//utils
import { shutterStockCancel, defaultQuery } from 'utils/api/embed';
import { SHUTTERSTOCK } from 'state/actions/embedsState/embedManagementState/image_status';
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/imageapi/imagepane/pane/images/shutterstock/shutterstock_styles';



/* ========== ~~~~~~~~~~ SHUTTERSTOCK ~~~~~~~~~~ ========== */
class ShutterStock extends Component {

	constructor(props) {
		super(props);
		this.processShutterStockSearch=this.processShutterStockSearch.bind(this);
	};
	
	componentDidMount(){
		this.processShutterStockSearch(this.props.query, this.props.page);
	}

	componentDidUpdate(prevProps){
		if (prevProps.query !== this.props.query || prevProps.page !== this.props.page){
			this.processShutterStockSearch(this.props.query, this.props.page);
		} 
	}

	componentWillUnmount(){
		if (!this.props.isDataReceived){
			shutterStockCancel();
		} 
	}

	processShutterStockSearch(query, page){
		if (query==''){
			this.props.getShutterStock(defaultQuery, page);
		} else {
			this.props.getShutterStock(query, page);
		}
	}
    
	renderImages() {
			return this.props.images.data.map((image, i) => {
				let thumbnail = image.assets.large_thumb;
				return (
					<span className={`imagecontainer`} key={i} >
						<Image key={`shutterstock-image-${i}`} provider={'SHUTTERSTOCK'} id={image.id}
							previewUrl={image.assets.huge_thumb}
							url={thumbnail.url} height={thumbnail.height} width={thumbnail.width} />
					</span>
				)
			});
	};

	render() {
		return (
			<div className={`pane shutterstock ${this.props.classes.shutterstock}`}>
				{(this.props.provider === SHUTTERSTOCK && this.props.isDataReceived && this.props.images.length > 0 && !this.props.error) ? <div className={`innerPane`}>
					{this.renderImages()}
				</div> : <Loading error={this.props.error} images={(this.props.isDataReceived && this.props.images.length === 0)} />}
			</div>
		)
	};
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(ShutterStock);
